export enum RecoverPhaseEnum {
  EmailSent,
  Enroll,
  Verification,
  Unspecified,
}
